import type { FilterRule } from '../../types';

/**
 * PD-17066 — rules shared by the Competitors tabs. Each tab's defining
 * predicate is a LOCKED, hidden filter rule, so the server applies it through
 * `getEnforcedFilters` (the list and its tab count agree) and the user cannot
 * remove it from the filter panel.
 */
export const ACTIVE_COMPETITORS_RULE: FilterRule = {
	defaultValue: [{ id: 'active', label: 'Active' }],
	locked: true,
	hidden: true,
};

export const INACTIVE_COMPETITORS_RULE: FilterRule = {
	defaultValue: [{ id: 'inactive', label: 'Inactive' }],
	locked: true,
	hidden: true,
};
